export default __webpack_public_path__ + "static/media/card1.54ce45f3.jpg";